import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSelectedQueryModal,
  getUniquenessScoreLoading,
} from "redux/SingleDataset/selectors";

import { getRemovedElementsByUniquenessCount } from "redux/SingleDataset/selectors";
import QueryModalTitle from "views/components/QueryModal/QueryModalTitle";
import ThresholdInput from "views/components/QueryModal/ThresholdInput";
import {
  createAndUpdateUniquenessFilter,
  isVqlQuery,
} from "helpers/utility/vqlHelpers";
import {
  setSelectedQueryModal,
  setUniquenessScoreLoading,
} from "redux/SingleDataset/actions";
import UniquenessIcon from "assets/icons/UniquenessIcon";
import QueryModal from "views/components/QueryModal";
import useVqlParams from "hooks/useVqlParams";

import styles from "./style.module.scss";
import { Filters, VqlQuery } from "types";

interface UniquenessQueryModalProps {
  editQueryId?: string;
}

export default function UniquenessQueryModal({
  editQueryId,
}: UniquenessQueryModalProps) {
  const { findVqlQuery, addVqlQuery, updateVqlQuery, vqlQueries } =
    useVqlParams();
  const oldQuery = editQueryId ? findVqlQuery(editQueryId, "uniqueness") : null;
  const selectedModalData = useSelector(getSelectedQueryModal);
  const isRemovedImagesLoading = useSelector(getUniquenessScoreLoading);
  const removedImages = useSelector(getRemovedElementsByUniquenessCount) || -1;

  const dispatch = useDispatch();

  const threshold = oldQuery?.uniqueness?.value || 0;
  const removedImageText =
    !!threshold && removedImages > -1 && `Removed ${removedImages} images`;

  const showRemovedImages = removedImageText && !isRemovedImagesLoading;

  const modalRef = useRef<HTMLDivElement>(null);
  const submitQuery = (value: number) => {
    dispatch(setUniquenessScoreLoading(true));
    const vqlQuery = createAndUpdateUniquenessFilter(value, editQueryId);
    editQueryId ? updateVqlQuery(vqlQuery) : addVqlQuery(vqlQuery);
    if (selectedModalData) {
      dispatch(
        setSelectedQueryModal({ ...selectedModalData, id: vqlQuery.id })
      );
    }
  };
  const handleSubmission = (value: number) => {
    if (value === threshold) return;
    else submitQuery(value);
  };

  useEffect(() => {
    const query = vqlQueries.find((query: VqlQuery) =>
      isVqlQuery(query, "uniqueness")
    );
    if (query) {
      dispatch(
        setSelectedQueryModal({ type: Filters.UNIQUENESS, id: query.id })
      );
    } else {
      submitQuery(threshold);
      dispatch(setSelectedQueryModal({ type: Filters.UNIQUENESS }));
    }
    // eslint-disable-next-line
  }, [editQueryId]);

  return (
    <QueryModal modalRef={modalRef}>
      <QueryModalTitle
        icon={<UniquenessIcon />}
        info="Selects a smaller and diverse set of images to represent the full range of your dataset."
      >
        Select Uniques
      </QueryModalTitle>
      <div className={styles.filterContent}>
        <ThresholdInput
          step={0.01}
          value={threshold}
          title="Uniqueness"
          onChange={handleSubmission}
        />
        {showRemovedImages && (
          <div className={styles.removedImages}>{removedImageText}</div>
        )}
      </div>
    </QueryModal>
  );
}
